// eslint-disable-next-line simple-import-sort/imports
import './injectDataDog';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'App';
import { init } from 'App/fingerprintClient';
import { config } from 'config';

window.addEventListener('DOMContentLoaded', () => {
  init(config.fingerprint.appKey);
});

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
